/**
 * ADR-166 — the pure logic behind the Employment Episode Discrepancies report,
 * kept out of the component so it can be tested in the node jest environment.
 */
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const fmtDay = (ymd) => (ymd ? dayjs.utc(ymd).format('DD/MM/YYYY') : 'Present');

export const SEVERITY_LABELS = { error: 'Error', warning: 'Warning', info: 'Info' };
// chipPalette tokens
export const SEVERITY_CHIP = { error: 'error', warning: 'warning', info: 'info' };

export const CATEGORY_OPTIONS = [
  { value: 'CONTRACT', label: 'Contract' },
  { value: 'EVENTS', label: 'Contract events' },
  { value: 'TIMELINE', label: 'Contract timeline' },
  { value: 'PERSON', label: 'Individual' }
];

export const SEVERITY_OPTIONS = Object.entries(SEVERITY_LABELS).map(([value, label]) => ({ value, label }));

/** Rows per "Load More", as on the Ingestion Sync Runs list. */
export const PAGE_SIZE = 50;

/** Check options for the filter, from the report's own list (only checks that are enabled). */
export const checkOptions = (report) => (report?.checks || [])
  .filter((c) => !report?.summary?.byCheck || report.summary.byCheck[c.code])
  .map((c) => ({ value: c.code, label: `${c.title} (${report.summary.byCheck[c.code]})` }));

/** Client-side filters: category, check, severity, Region, the individual (id from Search individuals). */
export const filterRows = (rows, { category = '', check = '', severity = '', regionId = '', employeeId = '' } = {}) =>
  (rows || []).filter((r) =>
    (!category || r.category === category)
    && (!check || r.check === check)
    && (!severity || r.severity === severity)
    && (!regionId || r.regionId === regionId)
    && (!employeeId || r.employeeId === employeeId));

export const contractLabel = (c) =>
  `${[c.type || 'Contract', c.company].filter(Boolean).join(' — ')}${c.primary ? ' (primary)' : ''}: ${fmtDay(c.startDate)} – ${fmtDay(c.endDate)}`;
